// flow weak

import React, {
  PureComponent
}                         from 'react';
import PropTypes          from 'prop-types';
import {
  AnimatedView,
  StatsCard,
  StatsTable,
  ScoreCard,
  StatsGraph,
  EarningGraph,
  Notifications,
  WorkProgress,
  TwitterFeed,
  TodoListDemo,
  TeamMatesDemo,

}                         from '../../../components';
import {
  TabPanel,
  TabPanelHeader,
  TabPanelBody,
  TabPanelBodyContent
}                         from '../../../components';


class PartnerTV extends PureComponent {
  static propTypes = {
    earningGraphLabels:   PropTypes.array,
    revenueChart:  PropTypes.shape({
      headers: PropTypes.array,
      data: PropTypes.array
    }),
    earningGraphDatasets: PropTypes.array,
    teamMatesIsFetching:  PropTypes.bool,
    teamMates:            PropTypes.arrayOf(
      PropTypes.shape({
        picture:      PropTypes.string,
        firstname:    PropTypes.string,
        lastname:     PropTypes.string,
        profile:      PropTypes.string,
        profileColor: PropTypes.oneOf(['danger', 'warning', 'info', 'success'])
      })
    ),
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    })
  };

  constructor(props) {
    super(props);
    console.log('constructor')
    console.log(props)
    this.state = {
      cm_monitoring_court_usage: [ 
          {name: 'Data', tablink: '1', isActive: true}, 
          {name: 'Total Court Usage', tablink: '2', isActive: false},
          
      ],
      cm_monitoring_rent: [ 
          {name: 'Data', tablink: '3', isActive: true}, 
          {name: 'Total Rent', tablink: '4', isActive: false},
          
      ],
      cm_monitoring_session_bookings: [
          {name: 'Data', tablink: '5', isActive: true}, 
          {name: 'Session Bookings', tablink: '6', isActive: false},
      ],
      cm_monitoring_hourly_court_usage: [ 
          {name: 'Data', tablink: '7', isActive: true}, 
          {name: 'Hourly Court Usage', tablink: '8', isActive: false},
          
      ],
      cm_monitoring_hourly_rent: [ 
          {name: 'Data', tablink: '9', isActive: true}, 
          {name: 'Hourly Rent', tablink: '10', isActive: false},
          
      ],            
    }
  }

  componentWillMount() {
    const { actions: { enterPage } } = this.props;
    enterPage('PartnerTV');
  }

  componentDidMount() {
    const {
      actions: {
        fetchStatsTableDataIfNeeded,
        fetchScoreCardDataIfNeeded,
      }
    } = this.props;
    $('.court-usage').find("a").trigger("click");
    $('.rental-usage').find("a").trigger("click");
    $('.session_bookings').find("a").trigger("click");
    $('.critical_session').find("a").trigger("click");
  }

  componentWillUnmount() {
    const { actions: { leavePage } } = this.props;
    leavePage('PartnerTV');
  }

  render() {
    console.log('expanded')
    console.log(this.props)
    const {
      teamMates,
      teamMatesIsFetching,
      earningGraphLabels,
      earningGraphDatasets,
      statsWidget,
      statsWidget2,
      statsCard,
      statsGraph,
      scoreCard,
      statsTable
    } = this.props;

    const {
      actions: {
        fetchStatsTableDataIfNeeded,
        fetchScoreCardDataIfNeeded,
        fetchStatsGraphDataIfNeeded
      }
    } = this.props;

    return(
      <AnimatedView>
        <div className="row">

          <div className="col-md-4 court-usage">
            <TabPanel>
              <TabPanelHeader tabItems={this.state.cm_monitoring_hourly_court_usage}/>
              <TabPanelBody>
                <TabPanelBodyContent id="7">
                  <StatsTable name="monitoring_hourly_court_usage" data={statsTable} displayName="Hourly Court Usage" reloadData={fetchStatsTableDataIfNeeded}/>
                </TabPanelBodyContent>
                <TabPanelBodyContent id="8">
                  <StatsGraph type="line" name="monitoring_hourly_court_usage_graph" data={statsGraph} reloadData={fetchStatsGraphDataIfNeeded}/>
                </TabPanelBodyContent>
              </TabPanelBody>
            </TabPanel>
          </div> 

          <div className="col-md-4 court-usage">
            <TabPanel>
              <TabPanelHeader tabItems={this.state.cm_monitoring_hourly_rent}/>
              <TabPanelBody>
                <TabPanelBodyContent id="9">
                  <StatsTable name="monitoring_hourly_rental" data={statsTable} displayName="Hourly Rental" reloadData={fetchStatsTableDataIfNeeded}/>
                </TabPanelBodyContent>
                <TabPanelBodyContent id="10">
                  <StatsGraph type="line" name="monitoring_hourly_rental_graph" data={statsGraph} reloadData={fetchStatsGraphDataIfNeeded}/>
                </TabPanelBodyContent>
              </TabPanelBody>
            </TabPanel>
          </div>


          <div className="col-md-4 session_bookings">
            <TabPanel>
              <TabPanelHeader tabItems={this.state.cm_monitoring_session_bookings}/>
              <TabPanelBody>
                <TabPanelBodyContent id="5">
                  <StatsTable name="monitoring_session_bookings" data={statsTable} displayName="Session Bookings" reloadData={fetchStatsTableDataIfNeeded}/>
                </TabPanelBodyContent>
                <TabPanelBodyContent id="6">
                  <StatsGraph type="line" name="monitoring_session_bookings_graph" data={statsGraph} reloadData={fetchStatsGraphDataIfNeeded}/>
                </TabPanelBodyContent>
              </TabPanelBody>
            </TabPanel>
          </div>          
        </div>

        <div className="row">
  
          <div className="col-md-4 court-usage">
            <TabPanel>
              <TabPanelHeader tabItems={this.state.cm_monitoring_court_usage}/>
              <TabPanelBody>
                <TabPanelBodyContent id="1">
                  <StatsTable name="monitoring_court_usage" data={statsTable} displayName="Court Usage" reloadData={fetchStatsTableDataIfNeeded}/>
                </TabPanelBodyContent>
                <TabPanelBodyContent id="2">
                  <StatsGraph type="line" name="monitoring_court_usage_graph" data={statsGraph} reloadData={fetchStatsGraphDataIfNeeded}/>
                </TabPanelBodyContent>
              </TabPanelBody>
            </TabPanel>
          </div>  
          <div className="col-md-4 rental-usage">
            <TabPanel>
              <TabPanelHeader tabItems={this.state.cm_monitoring_rent}/>
              <TabPanelBody>
                <TabPanelBodyContent id="3">
                  <StatsTable name="monitoring_rental" data={statsTable} displayName="Rental Trend" reloadData={fetchStatsTableDataIfNeeded}/>
                </TabPanelBodyContent>
                <TabPanelBodyContent id="4">
                  <StatsGraph type="line" name="monitoring_rental_graph" data={statsGraph} reloadData={fetchStatsGraphDataIfNeeded}/>
                </TabPanelBodyContent>
              </TabPanelBody>
            </TabPanel>
          </div>           

          <div className="col-md-4 session_bookings">
            <TabPanel>
              <TabPanelHeader tabItems={this.state.cm_monitoring_session_bookings}/>
              <TabPanelBody>
                <TabPanelBodyContent id="5">
                  <StatsTable name="monitoring_session_bookings" data={statsTable} displayName="Session Bookings" reloadData={fetchStatsTableDataIfNeeded}/>
                </TabPanelBodyContent>
                <TabPanelBodyContent id="6">
                  <StatsGraph type="line" name="monitoring_session_bookings_graph" data={statsGraph} reloadData={fetchStatsGraphDataIfNeeded}/>
                </TabPanelBodyContent>
              </TabPanelBody>
            </TabPanel>
          </div>



        </div>

        <div className="row">
          <div className="col-md-12 critical_session">
            <StatsTable name="critical_sessions" data={statsTable} displayName="Critical Sessions" nonCollapsible = {true} reloadData={fetchStatsTableDataIfNeeded}/>
          </div>        
        </div>


      </AnimatedView>
    );
  }
}

export default PartnerTV;



// WEBPACK FOOTER //
// ./src/app/views/partner/partnerTV/PartnerTV.js